import { handleRequest } from "../utilities/requestHandler";

export const sendMachineNotifyEmail = (req_body) => 
    handleRequest("post", "/support/send-machine-notify-email", req_body);